import { render, staticRenderFns } from "./xianshiyifen.vue?vue&type=template&id=60b5a6c6&scoped=true"
import script from "./xianshiyifen.vue?vue&type=script&lang=js"
export * from "./xianshiyifen.vue?vue&type=script&lang=js"
import style0 from "./xianshiyifen.vue?vue&type=style&index=0&id=60b5a6c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5a6c6",
  null
  
)

export default component.exports